// pages/NotFound.js
import React from 'react';

function Notfound() {
  return <h2>404 - Page Not Found</h2>;
}

export default Notfound;
